import { createRouter, createWebHistory } from 'vue-router';
import Dashboard from "@/components/Dashboard.vue";
import Login from "@/components/Login.vue";
import WalletRequest from "@/components/WalletRequest.vue";
import Story from "@/components/Story.vue";
import Affiliate from "@/components/Affiliate.vue";
import Setting from "@/components/Setting.vue";
import Author from "@/components/authors/Author.vue";
import CommentList from "@/components/CommentList.vue";
import WalletList from "@/components/WalletList.vue";
import PrStoryRequest from "@/components/PrStoryRequest.vue";
import NotificationList from "@/components/NotificationList.vue";
import User from "@/components/users/User.vue";
import CronJobs from "@/components/CronJobs.vue";
import Feedback from "@/components/Feedback.vue";
import AuthorPayView from "@/components/AuthorPayView.vue";
import AuthorEmail from "@/components/authors/AuthorEmail.vue";
import UserEmail from "@/components/users/UserEmail.vue";
import StoryViolate from "@/components/StoryViolate.vue";
import StoryReport from "@/components/StoryReport.vue";

const routes = [
    {
        path: '/',
        name: 'dashboard',
        title: 'Dashboard',
        component: Dashboard,
        meta: { requiresAuth: true }
    },
    {
        path: '/wallet_request',
        name: 'wallet_request',
        title: 'Yêu cầu nạp rút',
        component: WalletRequest,
        meta: { requiresAuth: true }
    },
    // {
    //     path: '/events',
    //     name: 'events',
    //     title: 'Sự kiện',
    //     component: EventBirthday,
    //     meta: { requiresAuth: true }
    // },
    {
        path: '/cron_jobs',
        name: 'cron_jobs',
        title: 'Cron Jobs',
        component: CronJobs,
        meta: { requiresAuth: true }
    },
    {
        path: '/story',
        name: 'story',
        title: 'Truyện',
        component: Story,
        meta: { requiresAuth: true }
    },
    {
        path: '/story_violate',
        name: 'story_violate',
        title: 'Truyện vi phạm',
        component: StoryViolate,
        meta: { requiresAuth: true }
    },
    {
        path: '/story_report',
        name: 'story_report',
        title: 'Báo cáo truyện',
        component: StoryReport,
        meta: { requiresAuth: true }
    },
    {
        path: '/affiliate',
        name: 'affiliate',
        title: 'Affiliate',
        component: Affiliate,
        meta: { requiresAuth: true }
    },
    {
        path: '/author',
        name: 'author',
        title: 'Author',
        component: Author,
        meta: { requiresAuth: true }
    },
    {
        path: '/user',
        name: 'user',
        title: 'User',
        component: User,
        meta: { requiresAuth: true }
    },
    {
        path: '/comment',
        name: 'comment',
        title: 'Comment',
        component: CommentList,
        meta: { requiresAuth: true }
    },
    {
        path: '/wallet',
        name: 'wallet',
        title: 'WalletList',
        component: WalletList,
        meta: { requiresAuth: true }
    },
    {
        path: '/feedback',
        name: 'feedback',
        title: 'Feedback',
        component: Feedback,
        meta: { requiresAuth: true }
    },
    {
        path: '/user_email',
        name: 'user_email',
        title: 'UserEmail',
        component: UserEmail,
        meta: { requiresAuth: true }
    },
    {
        path: '/author_email',
        name: 'author_email',
        title: 'AuthorEmail',
        component: AuthorEmail,
        meta: { requiresAuth: true }
    },
    {
        path: '/author_pay_view',
        name: 'author_pay_view',
        title: 'AuthorPayView',
        component: AuthorPayView,
        meta: { requiresAuth: true }
    },
    {
        path: '/notification',
        name: 'notification',
        title: 'NotificationList',
        component: NotificationList,
        meta: { requiresAuth: true }
    },
    {
        path: '/pr_story_request',
        name: 'qr_story_request',
        title: 'PrStoryRequest',
        component: PrStoryRequest,
        meta: { requiresAuth: true }
    },
    {
        path: '/settings',
        name: 'setting',
        title: 'Cài đặt chung',
        component: Setting,
        meta: { requiresAuth: true }
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/:catchAll(.*)',
        redirect: '/'
    }
];

const router = createRouter({
    mode: 'history',
    history: createWebHistory(),
    routes
});

// Hàm kiểm tra xác thực giả
const isAuthenticated = () => {
    // Thay thế bằng logic xác thực thực sự của bạn
    return localStorage.getItem('auth') === 'true' && localStorage.getItem('is_admin') === 'true' ;
};

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!isAuthenticated()) {
            next({ name: 'Login' });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
